export default __webpack_public_path__ + "static/media/premium.b46ea5ac.svg";